"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchIfKeyValuePipe = void 0;
const common_1 = require("@angular/common");
//ANGULAR2 BITS
const core_1 = require("@angular/core");
let SearchIfKeyValuePipe = class SearchIfKeyValuePipe {
    constructor(_datePipe, _decimalPipe) {
        this._datePipe = _datePipe;
        this._decimalPipe = _decimalPipe;
    }
    transform(value, term, key) {
        if (value) {
            if (term) {
                if (key) {
                    let ret = value.filter((item) => {
                        if (item[key] && item[key] != "") {
                            if (key == "updatedAt" || key == "datehour") {
                                if (typeof item[key] != "undefined" &&
                                    this._datePipe
                                        .transform(item[key], "medium")
                                        .toLowerCase()
                                        .indexOf(JSON.stringify(term).toLowerCase()) > -1) {
                                    return true;
                                }
                            }
                            else {
                                if (typeof item[key] == "boolean") {
                                    term = JSON.parse(term);
                                    return String(item[key]) == String(term);
                                }
                                if (typeof item[key] != "undefined" &&
                                    item[key] != "" &&
                                    JSON.stringify(item[key])
                                        .toLowerCase()
                                        .indexOf(JSON.stringify(term).toLowerCase()) > -1) {
                                    return true;
                                }
                            }
                            return false;
                        }
                        return true;
                    });
                    return ret;
                }
                return value;
            }
            else {
                return value;
            }
        }
    }
};
exports.SearchIfKeyValuePipe = SearchIfKeyValuePipe;
exports.SearchIfKeyValuePipe = SearchIfKeyValuePipe = __decorate([
    (0, core_1.Pipe)({ name: "searchIfKeyValue", pure: false }),
    __metadata("design:paramtypes", [common_1.DatePipe, common_1.DecimalPipe])
], SearchIfKeyValuePipe);
//# sourceMappingURL=search-if-key-value.pipe.js.map